module.exports = __webpack_public_path__ + "img/gift.512f67a4.gif";